import { Combination } from 'src/api';

/** The combination that discounts `productId` once every other product in it is selected too. */
export function applicableCombination(
  productId: string | undefined,
  selectedProductIds: ReadonlySet<string>,
  combinations: readonly Combination[],
): Combination | undefined {
  if (!productId) {
    return undefined;
  }
  return combinations.find(
    (combination) =>
      combination.product_ids.includes(productId)
      && combination.product_ids.every((id) => id === productId || selectedProductIds.has(id)),
  );
}

/** What a combination takes off, in cents: `percent_off` of the sum of the combined prices. */
export function combinationDiscountAmount(unitAmountsCents: readonly number[], combination: Combination): number {
  const sum = unitAmountsCents.reduce((total, amount) => total + amount, 0);
  return Math.round(sum * combination.percent_off / 100);
}
